import { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, TextField, InputAdornment, Skeleton } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import RoundButton from "../shared/components/round-btn";
import { Setting2, SearchNormal, Filter } from "iconsax-react";
import styles from './contacts.module.scss';
import ContactsUiStore from "./contacts-ui-store";
import RoundAutoComplete from "../shared/components/round-autocomplete";
import { ReactComponent as ArrowIcon } from '../../icons/arrow.svg';
import SearchBox from "../shared/components/search-box";
import Contact from "./contact";
import SettingsModal from "./settings-modal";
import FiltersModal from "./filters-modal";
import Filters from "./filters";

const uiStore = new ContactsUiStore();

const Contacts = observer(({ context }) => {
    const { contacts, userCards } = uiStore;
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState({})
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [filters, setFilters] = useState(null);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [query, setQuery] = useState('')
    const [selectedProfile, setSelectedProfile] = useState('All Cards');
    const [cardOptions, setCardOptions] = useState([]);

    const onQueryChange = (e) => {
        uiStore.filterContacts(e.target.value);
        setQuery(e.target.value);
    }

    useEffect(() => {

        async function fetchData() {
            setLoading(true);
            uiStore.initliazeContext(context);
            const setts = await uiStore.fetchSettings();
            setSettings(setts);
            await uiStore.fetchContacts(filters, selectedProfile.value);
            await uiStore.fetchCards();
            setLoading(false);
        }

        fetchData()
    }, [context, filters, selectedProfile]);

    useEffect(() => {
        if (userCards) {
            const options = [{ label: 'All Cards', value: 'All Cards' }]
            userCards.forEach(i => {
                options.push({ label: i.name, value: i._id })
            })
            setCardOptions(options);
        } else {
            setCardOptions({ label: 'All Cards', value: 'All Cards' })
        }

    }, [userCards])

    const updateFilters = (filters, clear = false) => {
        setFilters(filters)
        if ((filters?.length && filters[0].value.includes('Following')) || (filters?.length && filters[0].value.includes('All'))) {
            setSelectedProfile('All Cards');
        }
    }

    return (
        <>
            <Header page="contacts" />
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box>
                        <Grid container>
                            <Grid item lg={7} md={6} sm={6} xs={5} sx={{ mt: 2 }}>
                                <Typography variant="h5" color='#242333'><b>Contacts</b></Typography>
                            </Grid>
                            <Grid item lg={5} md={6} sm={6} xs={7} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <RoundAutoComplete
                                    disablePortal
                                    options={cardOptions}
                                    renderInput={(params) => <TextField {...params} />}
                                    sx={{ mr: '10px', width: '190px', display: { md: 'inline-flex', sm: 'none', xs: 'none' } }}
                                    disableClearable
                                    popupIcon={
                                        <ArrowIcon
                                            width="10"
                                            height="10"
                                            fill="#1D1761"
                                        />
                                    }
                                    onChange={(e, value) => setSelectedProfile(value)}
                                    value={selectedProfile}
                                />
                                <RoundButton
                                    startIcon={
                                        <Setting2
                                            size="24"
                                            variant="Bulk"
                                        />
                                    }
                                    variant="contained"
                                    color='lightblue'
                                    sx={{ display: { md: 'inline-flex', sm: 'none', xs: 'none' }, mr: 1, mt: 2 }}
                                    onClick={() => setShowSettingsModal(true)}
                                >

                                    Settings
                                </RoundButton>
                                <RoundButton
                                    variant="contained"
                                    color='lightblue'
                                    sx={{ display: { md: 'none', sm: 'inline-flex', xs: 'inline-flex' }, mr: 1, mt: 2 }}
                                    onClick={() => setShowFiltersModal(true)}
                                >

                                    <Filter
                                        size="24"
                                        variant="Bulk"
                                    />
                                </RoundButton>
                                <RoundButton
                                    variant="contained"
                                    color='lightblue'
                                    sx={{ display: { md: 'none', sm: 'inline-flex', xs: 'inline-flex' }, mr: 1, mt: 2 }}
                                    onClick={() => setShowSettingsModal(true)}
                                >
                                    <Setting2
                                        size="24"
                                        variant="Bulk"
                                    />
                                </RoundButton>
                            </Grid>
                        </Grid>
                    </Box>
                    <Grid container sx={{ mt: 3 }} columnSpacing={5}>
                        <Grid lg={4} md={4} display={{ md: 'block', sm: 'none', xs: 'none' }} item>
                            <Filters uiStore={uiStore} updateFilters={updateFilters} previousFilters={filters} selectedProfile={selectedProfile} />
                        </Grid>
                        <Grid lg={8} md={8} sm={12} xs={12} item>
                            <SearchBox
                                fullWidth
                                placeholder='Search...'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchNormal
                                                size="32"
                                                variant="Bulk"
                                            />
                                        </InputAdornment>
                                    )
                                }}
                                value={query}
                                onChange={onQueryChange}
                            />

                            {loading ?
                                <>
                                    <Skeleton variant="round" className={styles.contact} height={55} sx={{ mt: 2 }} />
                                    <Skeleton variant="round" className={styles.contact} height={55} sx={{ mt: 2 }} />
                                </>
                                :
                                contacts &&
                                <>
                                    <Typography color='#888' fontSize={14} sx={{ mt: 2 }}>Favorite</Typography>
                                    {Object.values(contacts).filter(i => i[0].favorite).map((contact, i) => (
                                        <Contact key={i} contact={contact} uiStore={uiStore} settings={settings} />
                                    ))
                                    }

                                    <Typography color='#888' fontSize={14} sx={{ mt: 2 }}>All</Typography>
                                    {Object.values(contacts).map((contact, i) => (
                                        <Contact key={i} contact={contact} uiStore={uiStore} settings={settings} />
                                    ))
                                    }
                                </>
                            }

                        </Grid>
                    </Grid>

                </Box>
            </Grid>
            <Footer></Footer>
            <SettingsModal
                uiStore={uiStore}
                settings={settings}
                setSettings={setSettings}
                show={showSettingsModal}
                setShow={setShowSettingsModal}
            />
            <FiltersModal
                uiStore={uiStore}
                updateFilters={updateFilters}
                previousFilters={filters}
                selectedProfile={selectedProfile}
                show={showFiltersModal}
                setShow={setShowFiltersModal}
                cardOptions={cardOptions}
                setSelectedProfile={setSelectedProfile}
            />
        </>
    );
});

export default Contacts;